import BaseController from "../baseController";

export class RecommendationController {
  urlBase = "/recommendations";

  constructor() {
    this.base = BaseController;
  }

  async getRecommendationsByProfile(profileId) {
    if (typeof profileId !== "string")
        throw new Error("Invalid profile id.");
    return this.base._get(`${this.urlBase}?$filter=profileId eq '${profileId}' `);
  }
}

const recommendationController = new RecommendationController();

export default recommendationController;